module.exports = __webpack_public_path__ + "img/mobile_crane_h1.fa25cf41.png";